import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import Renderer from "csi/heading/Renderer";
import html from "csi/html";
import locale from "csi/locale";
import ToggleButton from "dijit/form/ToggleButton";
import declare from "dojo/_base/declare";

const OwnershipTypeRenderer = declare(Renderer, {

	OWNERSHIP_TYPE_LINKED: "Linked",
	OWNERSHIP_TYPE_OWNED: "Owned",
	OWNERSHIP_TYPE_REFERENCED: "Referenced",

	/**
	 * Condition to enable/disable the toggle button
	 */
	canToggle(ctx: Context): boolean {
		return true;
	},

	/**
	 * Action to perform on selection of toggle
	 */
	onToggle(ctx: Context, refNode: HTMLElement): void {
	},

	/**
	 * Get the ownership type value (Linked, Owned, Referenced)
	 */
	getOwnershipType(ctx: Context): string {
		return this.OWNERSHIP_TYPE_OWNED;
	},

	/**
	 * Hide or show the toggle button
	 */
	shouldDisplayToggle(ctx: Context): boolean {
		return false;
	},

	/**
	 * @override
	 * Ownership type Renderer (Linked, Owned, Referenced)
	 */
	toHtmlStatic(ctx: Context, h: Heading, refNode: HTMLElement): boolean {
		const div = html.create("div", {
			class: "csi-flex-row csi-ownership-type",
		}, refNode);

		const ownershipType = this.getOwnershipType(ctx);

		html.create("span", {
			class: "csi-" + ownershipType.toLowerCase(),
			innerText: locale.resource("OwnershipType" + ownershipType),
		}, div);

		const self = this;

		if (this.shouldDisplayToggle(ctx)) {
			new ToggleButton({
				value: true,
				showLabel: true,
				class: "csi-button-switch",
				checked: true,
				disabled: !self.canToggle(ctx),
				onChange(val): void {
					self.onToggle(ctx, refNode);
				},
			}).placeAt(div);
		}

		return true;
	},
});

export = OwnershipTypeRenderer;
